import React from 'react'
import { Header2, Text } from '../../styles/Components'
import styled from '@emotion/styled'
import { mq } from '../../helpers'

const TaglineWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 88px 88px;

  ${mq('max', '768px')} {
    padding: 48px 16px;
  }
`

const Tagline = () => (
  <TaglineWrapper>
    <Header2 align="center" margin="0 0 15px 0">
      Salon-quality. Zero commute.
    </Header2>
    <Text fontSize={22} textAlign="center" spacing={0.22}>
      The city&apos;s best pros come to you so you can look and feel amazing
      without ever stepping into a salon.
    </Text>
  </TaglineWrapper>
)

export default Tagline
